import callAPI from '../ApiConfig'

const getMizanList = async (props) => {
    return await callAPI({
        route: "mizan_list/",
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const getMizan = async (props) => {
    return await callAPI({
        route: "mizan_list/" + props?.id,
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const addMizan = async (props) => {
    return await callAPI({
        route: "mizan_list/",
        method: "post",
        signal: props?.signal,
        data: props?.data,
        params: props?.params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        }
    })
}

const editMizan = async (props) => {
    return await callAPI({
        route: "mizan_list/" + props?.id,
        method: "put",
        signal: props?.signal,
        data: props?.data,
        params: props?.params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: 'application/json',
        }
    })
}

const deleteMizan = async (props) => {
    return await callAPI({
        route: "mizan_list/" + props?.id,
        method: "delete",
        signal: props?.signal,
        params: props?.params,
        headers: {}
    })
}

const getBelongings = async (props) => {
    return await callAPI({
        route: "mizan_list/" + props?.id + "/belongings",
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const addBelonging = async (props) => {
    return await callAPI({
        route: "mizan_list/" + props?.mizanId + "/belongings",
        method: "post",
        signal: props?.signal,
        data: props?.data,
        params: props?.params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        }
    })
}

const updateBelonging = async (props) => {
    return await callAPI({
        route: "mizan_list/" + props?.mizanId + "/belongings/" + props?.belongingId,
        method: "put",
        signal: props?.signal,
        data: props?.data,
        params: props?.params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        }
    })
}

const deleteBelonging = async (props) => {
    return await callAPI({
        route: "mizan_list/" + props?.mizanId + "/belongings/" + props?.belongingId,
        method: "delete",
        signal: props?.signal,
        params: props?.params,
        headers: {}
    })
}

const getGeofences = async (props) => {
    return await callAPI({
        route: "mizan_list/geofences",
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const mizanListAPI = {
    getMizanList,
    getMizan,
    addMizan,
    editMizan,
    deleteMizan,
    getBelongings,
    addBelonging,
    updateBelonging,
    deleteBelonging,
    getGeofences
}

export default mizanListAPI
